/**
 * AutomationConditionRow — one editable condition of an automation rule
 * (SE-5506).
 * @module features/player-kanban/components/molecules/AutomationConditionRow
 */

export { default } from "./AutomationConditionRowContainer";
export type { AutomationConditionRowContainerProps } from "./AutomationConditionRowContainer";
